import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppLayout } from '../../layouts'
import { Link } from 'react-router-dom'
import { Routes } from '../../routes'
import { tenantBranding } from '../../services'
import { useTheme } from '../../contexts/ThemeContext'
import { getTenantLogo } from '../../constants/Images'
import { getTenantName } from '../../utils/brandingStyles'

const TermsAndCondition = () => {
    const { t } = useTranslation()
    const { theme } = useTheme()

    return (
        <AppLayout>
            {/* Header with Logo */}
            <div className="container-fluid fixed-top mb-3 bg-black d-flex w-100">
                <div className="text-white fs-5 mb-0 pt-2" style={{ height: '50px' }}>
                    <span>
                        <img className="img-fluid" src={getTenantLogo(theme)} alt={getTenantName()} style={{ height: '30px' }} />
                    </span>
                </div>
            </div>
            <span className="mb-5 text-black">.</span>

            <div className="min-vh-100 w-100" style={{ overflowX: 'hidden' }}>
                {/* Back Navigation */}
                <div className="container my-4">
                    <Link to={Routes.HOMEVIEW} className="text-light fw-bold fs-4 text-decoration-none text-uppercase">
                        <div className="d-flex align-items-center">
                            <span><i className="fa-solid fa-arrow-left"></i></span>
                            <span className="ms-2">{t('navigation.backHome')}</span>
                        </div>
                    </Link>
                </div>

                <main className="w-100" style={{ overflow: 'hidden' }}>
                    {/* Hero Section */}
                    <section className="position-relative py-5" style={{ 
                        paddingTop: '2rem', 
                        paddingBottom: '5rem',
                        background: 'linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.9) 50%, rgba(0,0,0,1) 100%)'
                    }}>
                        <div className="container" style={{ maxWidth: '56rem' }}>
                            <div className="text-center">
                                <h1 className="display-3 fw-semibold text-white lh-base mb-4" style={{ 
                                    fontSize: 'clamp(2.5rem, 5vw, 3.5rem)' 
                                }}>
                                    {t('views.legalDocs.termsOfService.title')}
                                </h1>
                                <p className="fs-5 text-white-50 lh-base mx-auto" style={{ maxWidth: '42rem' }}>
                                    {t('views.legalDocs.termsOfService.subtitle')}
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Content Section */}
                    <section className="py-5 px-3 w-100" style={{ paddingTop: '4rem' }}>
                        <div className="container mx-auto w-100" style={{ maxWidth: '56rem' }}>
                            <div style={{ gap: '3rem' }} className="d-flex flex-column">
                                {/* Introduction */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.introduction.title')}
                                    </h2>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.introduction.p1')}
                                    </p>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.introduction.p2')}
                                    </p>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.introduction.p3')}
                                    </p>
                                </div>

                                {/* Account Registration */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.accountRegistration.title')}
                                    </h2>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.accountRegistration.p1')}
                                    </p>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.accountRegistration.p2')}
                                    </p>
                                </div>

                                {/* License Grant */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.licenseGrant.title')}
                                    </h2>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.licenseGrant.description')}
                                    </p>
                                    <ul className="text-white-50" style={{ 
                                        listStyleType: 'disc', 
                                        paddingLeft: '1.5rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.licenseGrant.item1')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.licenseGrant.item2')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.licenseGrant.item3')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.licenseGrant.item4')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.licenseGrant.item5')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.licenseGrant.item6')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.licenseGrant.item7')}</li>
                                    </ul>
                                </div>

                                {/* User Responsibilities */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.userResponsibilities.title')}
                                    </h2>
                                    <p className="text-white-50 mb-3">
                                        {t('views.legalDocs.termsOfService.userResponsibilities.description')}
                                    </p>
                                    <ul className="text-white-50" style={{ 
                                        listStyleType: 'disc', 
                                        paddingLeft: '1.5rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.userResponsibilities.item1')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.userResponsibilities.item2')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.userResponsibilities.item3')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.userResponsibilities.item4')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.userResponsibilities.item5')}</li>
                                    </ul>
                                </div>

                                {/* Acceptable Use Policy */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.acceptableUse.title')}
                                    </h2>
                                    <p className="text-white-50 mb-3">
                                        {t('views.legalDocs.termsOfService.acceptableUse.description')}
                                    </p>
                                    <ul className="text-white-50" style={{ 
                                        listStyleType: 'disc', 
                                        paddingLeft: '1.5rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.acceptableUse.item1')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.acceptableUse.item2')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.acceptableUse.item3')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.acceptableUse.item4')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.acceptableUse.item5')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.acceptableUse.item6')}</li>
                                    </ul>
                                </div>

                                {/* Intellectual Property Rights */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.intellectualProperty.title')}
                                    </h2>
                                    <div className="d-flex flex-column" style={{ gap: '1rem' }}>
                                        <div>
                                            <h3 className="h5 fw-semibold text-white mb-2">
                                                {t('views.legalDocs.termsOfService.intellectualProperty.ourIP.title')}
                                            </h3>
                                            <p className="text-white-50">
                                                {t('views.legalDocs.termsOfService.intellectualProperty.ourIP.description')}
                                            </p>
                                        </div>
                                        <div>
                                            <h3 className="h5 fw-semibold text-white mb-2">
                                                {t('views.legalDocs.termsOfService.intellectualProperty.yourContent.title')}
                                            </h3>
                                            <p className="text-white-50">
                                                {t('views.legalDocs.termsOfService.intellectualProperty.yourContent.description')}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Publicity Rights */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.publicityRights.title')}
                                    </h2>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.publicityRights.p1')}
                                    </p>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.publicityRights.p2')}
                                    </p>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.publicityRights.p3')}
                                    </p>
                                </div>

                                {/* Disclaimers */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.disclaimers.title')}
                                    </h2>
                                    <p className="text-white-50 mb-3">
                                        {t('views.legalDocs.termsOfService.disclaimers.p1')}
                                    </p>
                                    <p className="text-white-50 mb-3">
                                        {t('views.legalDocs.termsOfService.disclaimers.p2')}
                                    </p>
                                </div>

                                {/* Limitation of Liability */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.limitationOfLiability.title')}
                                    </h2>
                                    <p className="text-white-50 lh-base mb-3">
                                        {t('views.legalDocs.termsOfService.limitationOfLiability.p1')}
                                    </p>
                                    <p className="text-white-50">
                                        {t('views.legalDocs.termsOfService.limitationOfLiability.p2')}
                                    </p>
                                </div>

                                {/* Indemnification */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.indemnification.title')}
                                    </h2>
                                    <p className="text-white-50 lh-base">
                                        {t('views.legalDocs.termsOfService.indemnification.description')}
                                    </p>
                                </div>

                                {/* Termination */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.termination.title')}
                                    </h2>
                                    <p className="text-white-50 mb-3">
                                        {t('views.legalDocs.termsOfService.termination.description')}
                                    </p>
                                    <ul className="text-white-50 mb-3" style={{ 
                                        listStyleType: 'disc', 
                                        paddingLeft: '1.5rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.termination.item1')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.termination.item2')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.termination.item3')}</li>
                                        <li className="mb-2">{t('views.legalDocs.termsOfService.termination.item4')}</li>
                                    </ul>
                                    <p className="text-white-50">
                                        {t('views.legalDocs.termsOfService.termination.userTermination')}
                                    </p>
                                </div>

                                {/* Governing Law */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.governingLaw.title')}
                                    </h2>
                                    <p className="text-white-50 lh-base">
                                        {t('views.legalDocs.termsOfService.governingLaw.description')}
                                    </p>
                                </div>

                                {/* Contact */}
                                <div>
                                    <h2 className="h3 fw-bold text-white mb-3">
                                        {t('views.legalDocs.termsOfService.contact.title')}
                                    </h2>
                                    <p className="text-white-50 mb-3">
                                        {t('views.legalDocs.termsOfService.contact.description')}
                                    </p>
                                    <div className="border rounded p-4" style={{ 
                                        backgroundColor: 'rgba(255,255,255,0.05)',
                                        borderColor: 'rgba(255,255,255,0.1)'
                                    }}>
                                        <p className="text-white fw-medium mb-1">
                                            {t('views.legalDocs.termsOfService.contact.teamName')}
                                        </p>
                                        <p className="text-white-50 mb-1">
                                            {t('views.legalDocs.termsOfService.contact.email', { supportEmail: tenantBranding.supportEmail })}
                                        </p>
                                        <p className="text-white-50 mb-0">
                                            {t('views.legalDocs.termsOfService.contact.address')}
                                        </p>
                                    </div>
                                </div>

                                {/* Last Updated */}
                                <div className="border-top pt-4" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
                                    <p className="small text-white-50">
                                        {t('views.legalDocs.termsOfService.lastUpdated')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </AppLayout>
    )
}

export default TermsAndCondition